const join = (base, path) => {
  try {
    const parsed = new URL(base);
    if (!["https:", "http:"].includes(parsed.protocol) || parsed.username || parsed.password) return "";
    return new URL(path, `${parsed.origin}${parsed.pathname.replace(/\/$/, "")}/`).href;
  } catch { return ""; }
};

/** Prefills only blank draft URLs from this deployment's configured API and storefront, never overwriting saved values. */
export function gatewayUrlDefaults(value, provider = "multisafepay", api = process.env.REACT_APP_API_URL, site = process.env.REACT_APP_DOMAIN_URL) {
  const notificationUrl = join(api, provider === "zarinpal" ? "payments/v1/zarinpal/return" : "payments/v1/multisafepay/webhook");
  const redirectUrl = join(site, "dashboard/promotions?paymentReturned=1");
  return { ...value, notificationUrl: value.notificationUrl || notificationUrl, redirectUrl: value.redirectUrl || redirectUrl,
    cancelUrl: provider === "zarinpal" ? "" : value.cancelUrl || (redirectUrl ? `${redirectUrl}&cancelled=1` : "") };
}
